<script setup>
import SideNavContent from './SideNavContent.vue';

const open = defineModel('open');
</script>

<template>
    <template v-if="$store.state.deviceType === 'desktop'">
        <layout-content size="sm">
            <SideNavContent v-model:open="open" />
        </layout-content>
    </template>
    <template v-else>
        <Teleport to="body">
            <SideNavContent v-model:open="open" />
        </Teleport>
    </template>
</template>
